import { ErrorCode } from '@fluenceur/types';

const keys: Partial<Record<ErrorCode, string>> = {
  [ErrorCode.E_OTP_INVALID]: 'signup.verify.errors.invalid',
  [ErrorCode.E_OTP_EXPIRED]: 'signup.verify.errors.invalid',
  [ErrorCode.E_OTP_ALREADY_USED]: 'signup.verify.errors.invalid',
  [ErrorCode.E_OTP_MAX_ATTEMPTS]: 'signup.verify.errors.tooManyAttempts',
  [ErrorCode.E_OTP_RATE_LIMIT]: 'signup.verify.errors.tooManyCodes',
};

export function billingEmailError(failure: unknown, fallback: string): string {
  const code = (failure as { response?: { data?: { code?: ErrorCode } } } | null)?.response?.data
    ?.code;
  return code ? (keys[code] ?? fallback) : fallback;
}
